import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import { ProductGroupDependenciesByProductType } from "@/models/product.model";
import { ProductDependencyDto } from "@/api/product-dependencies";
import { DropdownOptionDto } from "@/api/models/common.model";
import { DeepPartial } from "@/utils/common.util";

interface StorageKnownState {
	productGroupsDependencies: ProductGroupDependenciesByProductType;
	productNonGroupsDependencies: ProductDependencyDto[];
}

export type StorageState = StorageKnownState & Record<string, DropdownOptionDto[]> & Record<string, any>;

export const genericSaleProcessInitialState = (): DeepPartial<StorageState> => {
	return {
		productGroupsDependencies: { fiber: [], mobile: [], voip: [] },
		productNonGroupsDependencies: []
	};
};

export default {
	state: genericSaleProcessInitialState(),
	actions,
	mutations,
	getters
};
